import { Collection } from 'modules/core/lib/mobx-rest'

import OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'

export class OverlapPeriods extends Collection<OverlapPeriod> {
  get cacheKey(): string {
    return 'overlapPeriods'
  }

  model() {
    return OverlapPeriod
  }

  getNonDefaultPeriods(id: string): OverlapPeriod[] {
    return this.models.filter(
      (period) => period.get('schedule_id') === id && !period.toJS().default
    )
  }

  getDefaultPeriod(id: string): OverlapPeriod | null | undefined {
    return this.models.find((period) => period.get('schedule_id') === id && period.toJS().default)
  }
}

const singleton: OverlapPeriods = new OverlapPeriods()

export default singleton
